var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',{staticClass:"purple-input required",attrs:{"value":_vm.value,"items":_vm.getTimeZones,"label":"Time Zone","rules":_vm.rules,"loading":_vm.loading,"disabled":_vm.disabled,"id":"timezone"},on:{"input":function($event){return _vm.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }